import React, { useEffect, useState } from "react";
import { getFeatureEvents, getEventsByCategory } from "../services/eventService";
import EventSlider from "./EventSlider";
import EventGrid from "./EventGrid";
import CategoriesSection from "./CategoriesSection";
import DigitalEvents from "./DigitalEvents";
import { useCity } from "../context/CityContext";
import UpcomingEvents from "./UpcomingEvents";


const HomePage = () => {
  const [featureImages, setFeatureImages] = useState([]);
  const [categorizedEvents, setCategorizedEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const digitalEventsData = categorizedEvents
    .find(cat => cat.categoryName === "Music")
    ?.events || [];

  const { city } = useCity();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);

      const [featureRes, allEventsRes] = await Promise.all([
        getFeatureEvents(city),
        getEventsByCategory(0, city, true),
      ]);

      const images = featureRes.data?.flatMap(e => e.imageList || []) || [];
      setFeatureImages(images);

      setCategorizedEvents(allEventsRes.data || []);

    } catch (error) {
      console.error("Error fetching home page data:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="p-4">Loading...</div>;
  }

  return (
    <>
<EventSlider images={featureImages} />
   {categorizedEvents
     .slice(0, 2)
     .map((category) => (
       <EventGrid
         title={category.categoryName}
         events={Array.isArray(category.events) ? category.events : []}
         limit={5}
         showViewAll={true}
       />
   ))}
    <CategoriesSection categories={categorizedEvents} />
    <DigitalEvents events={digitalEventsData} />
 <UpcomingEvents />
    </>
  );
};

export default HomePage;